export default {
  // Search related
  searchPlaceholder: "Search address/hash/investigation user ID",
  dataDetails: "Data Details",

  // Page title
  transactionDetails: "Transaction Details",

  // Buttons
  joinCanvas: "Add to Canvas",
  browserView: "View in Browser",

  // Transaction information
  transactionHash: "Transaction Hash",
  blockTime: "Block Time",
  inputAmount: "Input Amount",
  outputAmount: "Output Amount",
  transactionFee: "Transaction Fee",

  // Message prompts
  copySuccess: "Copy successful!",
  addressNotFound: "Address not found",
};
